// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoyaltyContactFormTextArea_wrapper__BRD_9"};